import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer'

const objectType = 'adult-surveillances';

class AdultSurveillancesServices extends BaseService {

  static getList(page) {

    return super.get(`adult_surveillances?page[number]=${page}&page[size]=${this.pageSize()}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static siteSearch(search) {
    return super.get(`trap_sites/site-search?search[field]=${search.field}&search[term]=${search.term}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

  static search(search, page) {

    return super.get(`adult_surveillances/search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static getDetails(id) {
    return super.get(`adult_surveillances/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities[objectType][object.result[objectType][0]];

        return Promise.resolve(camelizeKeys(data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static create(data) {
    return super.post(objectType, `adult_surveillances`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    return super.patch(objectType, `adult_surveillances/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`adult_surveillances/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default AdultSurveillancesServices;